(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-black-month"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('collection-black-month')) {
    customElements.define('collection-black-month', class extends HTMLElement {
      connectedCallback() {
        this.refresh = () => {
          clearTimeout(this.timer);
          const now = Date.now();
          const start = Date.parse(this.dataset.start);
          const end = Date.parse(this.dataset.end);
          const editor = this.dataset.editor === 'true';
          this.hidden = !(editor || (now >= start && now < end));
          const next = now < start ? start : now < end ? end : null;
          if (!editor && next) this.timer = setTimeout(this.refresh, Math.min(next - now, 2147483647));
        };
        this.refresh();
        document.addEventListener('visibilitychange', this.refresh);
        window.addEventListener('pageshow', this.refresh);
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        document.removeEventListener('visibilitychange', this.refresh);
        window.removeEventListener('pageshow', this.refresh);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
